// @ts-nocheck
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { Settings, LogOut, Users, CreditCard } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as DialerAuth from '@/services/dialer/DialerAuthService';
import NotificationBell from '@/components/dialer/NotificationBell';
import { OrganisationSwitcher } from '@/components/common/OrganisationSwitcher';
import { useLiveCallContact } from '@/hooks/useLiveCallContact';

interface CallerData {
  caller_name?: string | null;
}

interface UserHeaderBarProps {
  callerData?: CallerData | null;
  onViewChange?: (view: string) => void;
}

export default function UserHeaderBar({ callerData, onViewChange }: UserHeaderBarProps) {
  // ENG-9: no organisation switch (a full reload) during a call, while lines
  // ring, nor while an ended call waits for its qualification (ORG-SWITCH-1).
  const liveCall = useLiveCallContact();
  const { t } = useTranslation(['dialer', 'common']);
  const handleLogout = () => DialerAuth.logout();
  const navigate = useNavigate();

  return (
    <div
      className="flex items-center justify-end flex-shrink-0"
      style={{
        height: 40,
        background: 'var(--vf-bg)',
        padding: '0 12px',
        gap: 8,
      }}
    >
      <OrganisationSwitcher inCall={liveCall.blocksReload} />
      <NotificationBell />

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="flex items-center justify-center cursor-pointer transition-opacity hover:opacity-85"
            style={{
              width: 30,
              height: 30,
              borderRadius: 15,
              background: 'var(--vf-primary)',
              color: 'var(--vf-primary-fg)',
              fontSize: 11,
              fontWeight: 700,
              border: 'none',
            }}
            title={callerData?.caller_name || t('dialer:userHeader.user')}
          >
            {(callerData?.caller_name || '?').substring(0, 2).toUpperCase()}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-60">
          <div className="px-4 py-3 border-b" style={{ borderColor: 'var(--vf-border)' }}>
            <p className="text-sm font-bold">{callerData?.caller_name || t('common:entity.caller')}</p>
            <p className="text-[11px] mt-0.5" style={{ color: 'var(--vf-text-3)' }}>
              {t('dialer:nav.agentRole')}
            </p>
          </div>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={() => navigate('/team')} className="cursor-pointer text-xs gap-2">
            <Users size={13} />
            {t('dialer:userHeader.myTeam')}
          </DropdownMenuItem>
          {/* #74 -- l'entree "Parametres" a ete RETIREE de ce menu. Le client
              la voyait a deux endroits ; l'acces unique est celui du menu de
              gauche, en bas. Les redirections contextuelles (SMSPanel,
              TelephonyBlocker) ne sont PAS des acces de navigation : elles
              emmenent regler un blocage precis et restent legitimes. */}
          <DropdownMenuItem onClick={() => onViewChange?.('billing')} className="cursor-pointer text-xs gap-2">
            <CreditCard size={13} />
            {t('dialer:nav.billing')}
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={handleLogout}
            className="cursor-pointer text-xs gap-2"
            style={{ color: 'var(--vf-red)' }}
          >
            <LogOut size={13} />
            {t('dialer:userHeader.logout')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
